import { useEffect, useState } from "react";

export const DoorPreview = ({ model, open }) => {
  const [index, setIndex] = useState(0);
  const gallery = model.is_custom ? model.gallery : null;
  const count = gallery?.length || 0;
  useEffect(() => {
    setIndex(0);
    if (!open || count < 2) return;
    const timer = setInterval(() => setIndex((previous) => (previous + 1) % count), 2500);
    return () => clearInterval(timer);
  }, [open, count, model.id]);
  return <div className="relative bg-brand-green flex items-center justify-center p-3 md:p-10 aspect-[16/10] md:aspect-auto overflow-hidden">
    <img src={gallery?.[index] || model.image} alt={model.name} className="w-full h-full max-h-[26vh] md:max-h-[70vh] object-contain transition-opacity duration-500" data-testid="configure-image" />
    {count > 1 && <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-testid="configure-cycle-dots">
      {gallery.map((src, position) => <span key={src} data-testid={`configure-cycle-${position}`} className={`h-1 rounded-full ${position === index ? "w-6 bg-brand-gold" : "w-1.5 bg-brand-bone/40"}`} />)}
    </div>}
  </div>;
};